import AbstractClass from './MembershipStatusAbstractServices';

import { AwaitResponse } from '../../utils/MockUtils';

export default class MembershipStatusServices extends AbstractClass {
  /**
   * Returns mock details of the Membership Created/Pended page Reference Data API
   */
  static getReferenceData() {
    return AwaitResponse({
      membershipCreatedInformationText: {
        informationText:
          '<p>We&rsquo;ve sent you a certificate of cover and product guide.&nbsp;<br />\r\nTogether these provide the details of your cover. Please read this carefully and retain them for your reference.</p>\r\n\r\n<p>You&rsquo;ll receive your member card in the next few days.&nbsp;Keep your card with you for instant recognition and convenient on-the-spot claims at many extras providers.</p>\r\n\r\n<p>In the meantime, please make note of your member number.</p>\r\n\r\n<p>Register for the&nbsp;<a href="~/portal" target="_blank">Defence Health Member Portal</a>.&nbsp; You can use this anytime, anywhere to:</p>\r\n\r\n<ul>\r\n\t<li>View your cover&mdash;check your benefits, limits and claim history</li>\r\n\t<li>Update your account&mdash;change your cover or payment information</li>\r\n\t<li>Make a claim, or</li>\r\n\t<li>Use our tools and resources&mdash;find a provider, get a quote, and more</li>\r\n</ul>\r\n',
      },
      membershipCoveredInformationText: {
        informationText:
          '<p>Premium payments are paid in advance. As your start date and nominated direct debit date are different, you have two options:</p>\r\n\r\n<ul>\r\n\t<li>Pay an interim premium payment now to cover this period,&nbsp;</li>\r\n\t<li>Pay a larger first premium payment later, on your nominated payment date.</li>\r\n</ul>\r\n\r\n<p>If you choose to pay now, you&#39;ll be covered immediately (subject to waiting periods).&nbsp;</p>\r\n\r\n<p>If you choose to pay later, you will be unable to claim until we receive your first payment (subject to waiting periods).</p>\r\n',
      },
      membershipCoveredMustPayNowInformationText: {
        informationText: '<p>Premium payments are paid in advance. You will be unable to claim until we receive your first payment.</p>\r\n',
      },
      membershipPaymentNowInformationText: {
        informationText:
          '<p>Paying an interim premium payment now ensures you can claim between your nominated start date and your first nominated payment date.</p>\r\n\r\n<p>Your regular ongoing premium will be deducted according to your direct debit arrangement.</p>\r\n',
      },
      membershipPaymentLaterInformationText: {
        informationText:
          '<p>By electing to pay later, your first premium payment will be a little higher than your ongoing premium payments. This is because this payment will include the amount required to cover the period between your cover start date and nominated direct debit date.</p>\r\n',
      },
      membershipCreatedMembershipPendingInformationText: {
        informationText: '<p>Thanks for joining Defence Health, where we look after our own.</p>\r\n',
      },
      membershipCreatedMembershipPendingInformationCallOutText: {
        informationText:
          '<h2>Almost there</h2>\r\n\r\n<p>We need some more information to finalise setting up your membership.</p>\r\n\r\n<p>We&#39;ll be in touch within the next three business days.</p>\r\n\r\n<p>If you have any questions about Defence Health or your membership, please <a href="~/Support/Contact-Us" target="_blank">contact us</a>.</p>\r\n',
      },
      appliedLoadingsInformationText: {
        informationText:
          'LHC loading has been applied based on your age. If you are eligible for a reduced loading, please <a href="/Support/Contact-Us">contact us</a>. Our friendly team will be happy to help you.',
      },
    });
  }

  static getProrataPrice(memberNumber, payload) {
    logger.log('MembershipStatusServices :: getProrataPrice() - memberNumber:', memberNumber, ', startDate:', payload);
    return AwaitResponse({
      initialPayment: 25.0,
    });
  }

  static getPremiumAdjustments(memberNumber, showPremiumPaymentAmount, coverStartDate, startDateCatchUp) {
    logger.log(
      'MembershipStatusServices :: getPremiumAdjustments() - memberNumber:',
      memberNumber,
      ', showPremiumPaymentAmount:',
      showPremiumPaymentAmount,
      ', coverStartDate:',
      coverStartDate,
      ', startDateCatchUp:',
      startDateCatchUp,
    );
    return AwaitResponse({
      prorataPrice: 12.0,
      policyCrn: 'string',
      nextContributionDate: '2023-12-17',
      futureContributionDate: '2024-01-17',
      frequency: 'fortnightly',
      standardPremiumPaymentAmount: 100.0,
    });
  }

  static async submitImmediatePaymentRequest(memberNumber, creditCardToken, sttToken) {
    logger.log('MembershipStatusServices :: payNow() - memberNumber:', memberNumber, ', creditCardToken:', creditCardToken, ', sttToken:', sttToken);
    return AwaitResponse({
      // FIXME: 04/08/2021 LN - The below model has not been confirmed so avoid using it in code for now.
      invoiceId: '12345',
      startDate: '2021-07-21T03:16:03.242Z',
      success: true,
      message: 'Payment successful.',
    });
  }
}
